/** 입력 유효성 검사 타입 **/
export enum InputValidatorType {
    ALLOW_ALL,
    KOREAN_ONLY,
    NUMBER_ONLY,
    PASSWORD,
    ALPHABET_NUMBER,
    NICKNAME,
  }
  